import _ from 'lodash';

import { LoanStatus } from 'constants/loanApplication';
import { tagPropsByStatus } from 'constants/loanProgress';
import { TagColor } from 'constants/ui';

const getLoanStatusWithMilestones = ({
  isMilestoneBasedStatusEnabled,
  isWithLegacy,
  milestoneProgress,
  statusDescription,
}) => {
  if (isMilestoneBasedStatusEnabled && !isWithLegacy) {
    return {
      color: TagColor.BLUE,
      text: milestoneProgress?.name || LoanStatus.UNDEFINED,
    };
  }

  return {
    ...tagPropsByStatus[statusDescription?.status],
    text: '',
  };
};

const getIsLineProgressDisplayedWithMilestones = ({
  isMilestoneBasedStatusEnabled,
  isWithLegacy,
  milestoneProgress,
  statusDescription,
  percentDescription,
}) => {
  if (isMilestoneBasedStatusEnabled && !isWithLegacy) {
    return !_.isNil(milestoneProgress?.progress);
  }

  const isUndefinedStatus = statusDescription?.status === LoanStatus.UNDEFINED;

  return !_.isNil(percentDescription) && !isUndefinedStatus;
};

const getProgressPercentageWithMilestones = ({
  isMilestoneBasedStatusEnabled,
  isWithLegacy,
  legacyProgressPercentage,
  milestoneProgress,
}) => {
  const value =
    isMilestoneBasedStatusEnabled && !isWithLegacy
      ? milestoneProgress?.progress
      : legacyProgressPercentage;

  return Math.floor(value);
};

export const getProgressPercentageDetails = ({
  isMilestoneBasedStatusEnabled = true,
  isWithLegacy,
  milestoneProgress,
  statusDescription,
  percentDescription,
  legacyProgressPercentage,
}) => ({
  status: getLoanStatusWithMilestones({
    isMilestoneBasedStatusEnabled,
    isWithLegacy,
    milestoneProgress,
    statusDescription,
  }),
  isProgressDisplayed: getIsLineProgressDisplayedWithMilestones({
    isMilestoneBasedStatusEnabled,
    isWithLegacy,
    milestoneProgress,
    statusDescription,
    percentDescription,
  }),
  progress: getProgressPercentageWithMilestones({
    isMilestoneBasedStatusEnabled,
    isWithLegacy,
    legacyProgressPercentage,
    milestoneProgress,
  }),
});
